import { environment } from '@env/environment';

export default {
  oidc: {
    clientId: `${environment.oktaClientId}`,
    issuer: `${environment.oktaBaseUrl}${environment.oktaAuthUrl}`,
    oktaBaseUrl: environment.oktaBaseUrl,
    oktaRedirectUri: `${environment.webUrl}${environment.oktaRedirectUri}`,
    signinReturnUri: `${environment.webUrl}${environment.signinReturnUri}`,
    loginReturnUri: `${environment.webUrl}${environment.loginReturnUri}`,
    scopes: ['openid', 'profile', 'email', 'offline_access'],
    pkce: true,
    oktaIdp: environment.oktaIdp,
  },
};
